












import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  props: {
    active: {
      type: Boolean,
      default: false,
    },

    rule: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const onClick = () => emit('click', props.rule);

    return { onClick };
  },
});
